import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SimpleDocumentViewerComponent } from '../simple-document-viewer/simple-document-viewer.component';
import { DocumentViewerInfo, DocumentViewerService } from './document-viewer-panel.service';

@Component({
  selector: 'lib-document-viewer-panel',
  standalone: true,
  imports: [CommonModule, SimpleDocumentViewerComponent, PortalModule],
  templateUrl: './document-viewer-panel.component.html',
  styleUrls: ['./document-viewer-panel.component.scss'],
})
export class DocumentViewerPanelComponent {
  fileInfo: DocumentViewerInfo | null = null;

  @Input()
  operationType?: string;

  @Input()
  productType?: string;

  @Input()
  personType?: string;

  constructor(private documentViewerService: DocumentViewerService) {
    this.documentViewerService.fileViewerInfo$.subscribe(value => {
      this.fileInfo = value;
      this.operationType = value?.ficheConseilInfo?.operationType;
      this.productType = value?.ficheConseilInfo?.enveloppe.libelle;
      this.personType = value?.ficheConseilInfo?.investisseurType;
      this.operationType = value?.ficheConseilInfo?.conseilConfigLibelle;
    });
  }

  closeDocumentViewer() {
    this.documentViewerService.closeDocumentViewer();
  }
}
